import React from 'react';
import GDPRModal from './GDPR/GDPRModal';
import AppLink from '../links/AppLink';
import styles from './Top.module.less';

export default function Top() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.column}>
          <a
            href="/guided-lessons-overview/"
            data-cid="11.2168"
            className={styles.heading}
          >
            Guided Lessons
          </a>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <a
                href="/progress-tracker/"
                data-cid="11.2169"
                className={styles.text}
              >
                Progress Tracker
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="/classroom-mode/"
                data-cid="11.217"
                className={styles.text}
              >
                Classroom Mode
              </a>
            </li>
            <li className={styles.listItem}>
              <a href="/skills/" data-cid="11.2171" className={styles.text}>
                Skills Progression
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.column}>
          <AppLink
            href="/resources/"
            data-cid="11.2172"
            className={styles.heading}
          >
            Learning Library
          </AppLink>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <AppLink
                href="/worksheets/"
                data-cid="11.2173"
                className={styles.text}
              >
                Worksheets
              </AppLink>
            </li>
            <li className={styles.listItem}>
              <AppLink href="/games" data-cid="11.2174" className={styles.text}>
                Games
              </AppLink>
            </li>
            <li className={styles.listItem}>
              <AppLink
                href="/workbooks/"
                data-cid="11.2175"
                className={styles.text}
              >
                Workbooks
              </AppLink>
            </li>
            <li className={styles.listItem}>
              <AppLink
                href="/activity/"
                data-cid="11.2176"
                className={styles.text}
              >
                Activities
              </AppLink>
            </li>
            <li className={styles.listItem}>
              <AppLink
                href="/songs/"
                data-cid="11.2177"
                className={styles.text}
              >
                Songs
              </AppLink>
            </li>
            <li className={styles.listItem}>
              <AppLink
                href="/stories/"
                data-cid="11.2178"
                className={styles.text}
              >
                Stories
              </AppLink>
            </li>
            <li className={styles.listItem}>
              <AppLink
                href="/exercises/"
                data-cid="11.2179"
                className={styles.text}
              >
                Exercises
              </AppLink>
            </li>
          </ul>
        </div>

        <div className={styles.column}>
          <a
            href="/teaching-tools/"
            data-cid="11.218"
            className={styles.heading}
          >
            Teaching Tools
          </a>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <AppLink
                href="/lesson-plans/"
                data-cid="11.2181"
                className={styles.text}
              >
                Lesson Plans
              </AppLink>
            </li>
            <li className={styles.listItem}>
              <a
                href="/worksheet-generator/"
                data-cid="11.2182"
                className={styles.text}
              >
                Worksheet Generator
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="/common-core/"
                data-cid="11.2183"
                className={styles.text}
              >
                Common Core Resources
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="/teaching-tools/"
                data-cid="11.2184"
                className={styles.text}
              >
                More Teaching Tools
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.column}>
          <a
            href="/school-accounts/"
            data-cid="11.2185"
            className={styles.heading}
          >
            Schools
          </a>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <a
                href="/request-quote/"
                data-cid="11.2186"
                className={styles.text}
              >
                Get a Quote
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="/school-purchase/"
                data-cid="11.2187"
                className={styles.text}
              >
                Buy School License
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.column}>
          {/*todo: is it ok to add noreferrer*/}
          <a
            href="https://support.education.com/"
            data-cid="11.2188"
            target="_blank"
            className={styles.heading}
            rel="noopener noreferrer"
          >
            Support
          </a>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <a href="/pricing/" data-cid="11.2189" className={styles.text}>
                Pricing
              </a>
            </li>
            <li className={styles.listItem}>
              <a href="/gift/" data-cid="11.2203" className={styles.text}>
                Give Gift
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="/gift/redeem/"
                data-cid="11.2204"
                className={styles.text}
              >
                Redeem Gift
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="/school-accounts/"
                data-cid="11.219"
                className={styles.text}
              >
                Schools
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="https://support.education.com/"
                data-cid="11.2191"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.text}
              >
                FAQs
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="http://www.ixl.com/feedback/educationdotcom"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.text}
              >
                Tell us what you think
              </a>
            </li>
            <li className={styles.listItem}>
              <a href="/privacy/" data-cid="11.2192" className={styles.text}>
                Privacy Policy
              </a>
            </li>
            <li className={styles.listItem}>
              <strong>
                <a href="/coppa/" data-cid="11.2193" className={styles.text}>
                  COPPA Privacy Policy
                </a>
              </strong>
            </li>
            <li className={styles.listItem}>
              <a href="/terms/" data-cid="11.2194" className={styles.text}>
                Terms of Service
              </a>
            </li>

            {/* todo: show only in gdpr required countries*/}
            <li className="in-gdpr-enabled">
              <GDPRModal />
            </li>
          </ul>
        </div>

        <div className={styles.column}>
          <a href="/about/" data-cid="11.2195" className={styles.heading}>
            About Us
          </a>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <a href="/about/" data-cid="11.2196" className={styles.text}>
                Company
              </a>
            </li>
            <li className={styles.listItem}>
              <a href="/reviews/" data-cid="11.2202" className={styles.text}>
                Reviews
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="https://blog.education.com"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.text}
              >
                Blog
              </a>
            </li>
            <li className={styles.listItem}>
              <a
                href="/about/press/"
                data-cid="11.2199"
                className={styles.text}
              >
                Press
              </a>
            </li>
            <li className={styles.listItem}>
              <a href="/sitemap/" className={styles.text}>
                Site Map
              </a>
            </li>
            {/*todo: is it ok to add noreferrer*/}
            <li className={styles.listItem}>
              <a
                href="https://support.education.com/"
                data-cid="11.2201"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.text}
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
